const createForm = (method, action, data) => {
  const form = document.createElement('form');
  form.method = method;
  form.action = action;

  for (const [name, value] of Object.entries(data)) {
    const input = createInput(name, value);
    form.appendChild(input);
  }

  return form;
};

const parseInputObjectValue = value => {
  if (value !== null && typeof value === 'object') {
    return JSON.stringify(value);
  }

  return value;
};

const createInput = (name, value) => {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = parseInputObjectValue(value);

  return input;
};

export default {
  inserted(el, binding, vnode) {
    const action = el.getAttribute('action');
    const method = el.getAttribute('method');

    vnode.elm.addEventListener('submit', async () => {
      if (await vnode.componentInstance.hasValidationErrors()) {
        return;
      }

      const form = createForm(method, action, binding.value());
      document.body.appendChild(form);

      form.submit();
    });
  },
};
